import { Component } from '@verndale/core';

class Module extends Component {
  setupDefaults() {
  }

  addListeners() {
    window.addEventListener('load', this.runAnimations.bind(this));
  }

  runAnimations() {
    this.el.classList.add('simple-masthead--loaded');
  }
}

export default Module;
